import React, { useState } from 'react';
import './featureTable.css';
import { IpaType } from '../../phonemes/ipa';
import { IpaKeyboard } from '../widgets/IpaKeyboard';
import { ColumnAlign } from '../widgets/ColumnAlign';

/** show vowel lengths with UI for changing them & adding new ones */
export function PhonemeLengths(props: {
  readonly lengthMap: Record<IpaType, number>;
  readonly setLength: (phoneme: IpaType, length: number) => void;
  readonly clearLengths: () => void;
}) {
  const pl = props.lengthMap;
  const all = Object.getOwnPropertyNames(pl);

  return (<>
    <ColumnAlign width={240}>{[
      <div key={1} className='smallTitle'>Vowel lengths</div>,
      <button key={2} onClick={() => props.clearLengths()} disabled={all.length === 0}>clear lengths</button>
    ]}</ColumnAlign>
    <div style={{ display: "flex", justifyContent: "center" }}>
      <table>
        <thead>
          <tr>
            <th>phoneme</th>
            <th>length (ms)</th>
          </tr>
        </thead>
        <tbody>
          {all.map((p, i) => <LengthRow phonemeLength={[p, pl[p]]} setLength={props.setLength} key={`${p}-${i}`} />)}
          <AddLengthRow setLength={props.setLength} />
        </tbody>
      </table>
    </div>
  </>);
}

/** show a phoneme & let them type in a length */
function LengthRow(props: {
  readonly phonemeLength: [IpaType, number];
  readonly setLength: (phoneme: IpaType, length: number) => void;
}) {
  const [phoneme] = useState(props.phonemeLength[0]);
  const [length, setLength] = useState(props.phonemeLength[1].toString());
  const [canChange, setCanChange] = useState(false);

  function changeLength(len: string) {
    const hasChanged = len !== props.phonemeLength[1].toString();
    setLength(len);
    const n = Number.parseInt(len);
    const isValid = !isNaN(n) && 0 < n && n < 1000;
    setCanChange(isValid && hasChanged);
  }

  function nowUse() {
    const n = Number.parseInt(length);
    if (!isNaN(n)) {
      props.setLength(phoneme, n);
      setCanChange(false);
    }
  }

  return (
    <tr>
      <th>{phoneme}</th>
      <td>
        <input size={3} spellCheck={false} value={length} onChange={(e) => changeLength(e.target.value)} />
        <button onClick={() => nowUse()} disabled={!canChange}>change</button>
      </td>
    </tr>
  );
}


/** let them type in a phoneme & length */
function AddLengthRow(props: {
  readonly setLength: (phoneme: IpaType, length: number) => void;
}) {
  const [phoneme, setPhoneme] = useState('');
  const [length, setLength] = useState('180');
  const [canUse, setCanUse] = useState(false);

  function changePhoneme(ph: string) {
    setPhoneme(ph);
    const n = Number.parseInt(length);
    setCanUse(!isNaN(n) && ph !== '');
  }

  function changeLength(len: string) {
    setLength(len);
    const n = Number.parseInt(len);
    setCanUse(!isNaN(n) && phoneme !== '');
  }

  function addPhonemeLength() {
    const n = Number.parseInt(length);
    if (phoneme !== '' && !isNaN(n)) {
      props.setLength(phoneme, n);
      setPhoneme('');
      setLength('180');
      setCanUse(false);
      document.getElementById('phoneme')?.focus();
    }
  }

  return (
    <tr>
      <th>
        <IpaKeyboard cols={3} value={phoneme} onChange={changePhoneme} useInput={true} id="phoneme" />
      </th>
      <td className='alternate'>
        <input size={3} maxLength={3} spellCheck={false} value={length} onChange={(e) => changeLength(e.target.value)} />
        <button onClick={() => addPhonemeLength()} disabled={!canUse}>add</button>
      </td>
    </tr>
  );
}
